export default "__VITE_ASSET__B169NLZe__"